"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomEvents = exports.CustomEmitter = void 0;
const events_1 = __importDefault(require("events"));
const typings = __importStar(require("@monorepo/typings/sdk"));
class CustomEmitter extends events_1.default {
}
exports.CustomEmitter = CustomEmitter;
class CustomEvents extends CustomEmitter {
    sdk;
    api;
    constructor(sdk) {
        super();
        this.sdk = sdk;
        this.api = this.sdk.api;
        this.api.on(typings.EVENTS.PING, () => this.sdk.emit(typings.EVENTS.PING));
        this.api.on(typings.EVENTS.RESPONSE, (resp) => {
            this.sdk.emit(typings.EVENTS.RESPONSE, resp);
            this.sdk.emit(typings.EVENTS.ALL, {
                type: typings.EVENTS.RESPONSE,
                resp,
            });
        });
        this.api.on(typings.EVENTS.USER_CHANGE, (user) => {
            this.sdk.emit(typings.EVENTS.USER_CHANGE, user);
            this.sdk.emit(typings.EVENTS.ALL, {
                type: typings.EVENTS.USER_CHANGE,
                user,
            });
        });
        this.api.on(typings.EVENTS.NETWORK_CHANGE, (network) => {
            this.sdk.emit(typings.EVENTS.NETWORK_CHANGE, network);
            this.sdk.emit(typings.EVENTS.ALL, {
                type: typings.EVENTS.NETWORK_CHANGE,
                network,
            });
        });
        this.api.on(typings.EVENTS.OPEN, () => {
            this.sdk.emit(typings.EVENTS.OPEN);
            this.sdk.emit(typings.EVENTS.ALL, {
                type: typings.EVENTS.OPEN,
            });
        });
        this.api.on(typings.EVENTS.CLOSE, () => {
            this.sdk.emit(typings.EVENTS.CLOSE);
            this.sdk.emit(typings.EVENTS.ALL, {
                type: typings.EVENTS.CLOSE,
            });
        });
        this.api.on(typings.EVENTS.SIGNOUT, () => {
            this.sdk.emit(typings.EVENTS.SIGNOUT);
            this.sdk.emit(typings.EVENTS.ALL, {
                type: typings.EVENTS.SIGNOUT,
            });
        });
    }
}
exports.CustomEvents = CustomEvents;
